module.exports = __webpack_public_path__ + "assets/wind.eb52a576.svg";